const SDK_SCRIPT_ID = "facebook-jssdk";
const SDK_TIMEOUT_MS = 15000;

let sdkPromise = null;
let initializedAppId = null;

const resetSdk = () => {
  document.getElementById(SDK_SCRIPT_ID)?.remove();
  delete window.FB;
  window.fbAsyncInit = undefined;
  sdkPromise = null;
  initializedAppId = null;
};

export const loadMetaSdk = () => {
  if (window.FB) return Promise.resolve(window.FB);
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise((resolve, reject) => {
    const fail = (message) => {
      sdkPromise = null;
      reject(new Error(message));
    };

    window.fbAsyncInit = () => resolve(window.FB);

    if (!document.getElementById(SDK_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = SDK_SCRIPT_ID;
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.onerror = () => fail("No se pudo cargar el SDK de Meta");
      document.body.appendChild(script);
    }

    setTimeout(() => {
      if (window.FB) resolve(window.FB);
      else fail("El SDK de Meta tardó demasiado en cargar");
    }, SDK_TIMEOUT_MS);
  });

  return sdkPromise;
};

export const initMetaApp = async ({ appId, version }) => {
  if (!appId) throw new Error("Falta configurar la app de Meta");
  if (initializedAppId && initializedAppId !== appId) resetSdk();
  const FB = await loadMetaSdk();
  if (initializedAppId !== appId) {
    FB.init({ appId, version, cookie: true, xfbml: false });
    initializedAppId = appId;
  }
  return FB;
};

export const loginWithMetaApp = async ({ appId, version, scope, fields = "name,email,picture" }) => {
  const FB = await initMetaApp({ appId, version });

  return new Promise((resolve) => {
    FB.login(
      (result) => {
        if (!result?.authResponse) {
          resolve({ status: result?.status || "unknown" });
          return;
        }
        FB.api("/me", { fields }, (me) => resolve({ ...(me || {}), ...result.authResponse }));
      },
      { scope }
    );
  });
};
